import { withAuthGate } from '@sunrise-ui/composites';
import IntrosMadeView from '@templates/IntrosMadeView';
import React from 'react';

function DeniedIntrosMadeScreen() {
  return <IntrosMadeView state="denied" />;
}

export default withAuthGate(DeniedIntrosMadeScreen);
